var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_105_9846)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_9846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 15.3048L26.7649 16.3343L25.9999 17.2969C23.7331 17.2969 21.8894 19.1437 21.8894 21.4141V22.9912C21.8894 23.5417 21.4439 23.9873 20.8949 23.9873C20.3459 23.9873 19.9004 23.5417 19.9004 22.9912V21.4141C19.9004 18.0453 22.6365 15.3048 25.9999 15.3048Z",
    fill: "#FFE666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0995 21.4141V22.9913C32.0995 23.5418 31.654 23.9874 31.105 23.9874C30.556 23.9874 30.1105 23.5418 30.1105 22.9913V21.4141C30.1105 19.1437 28.2667 17.297 26 17.297V15.3048C29.3633 15.3048 32.0995 18.0453 32.0995 21.4141Z",
    fill: "#FFC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 21.9952L29.564 28.9731L26.0002 33.7656H21.0875C19.5805 33.7656 18.354 32.537 18.354 31.027V24.7337C18.354 23.2236 19.5805 21.9951 21.0875 21.9951H26.0002V21.9952Z",
    fill: "#FFE666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6462 24.7337V31.027C33.6462 32.537 32.4197 33.7656 30.9127 33.7656H26V21.9952H30.9127C32.4197 21.9952 33.6462 23.2236 33.6462 24.7337Z",
    fill: "#FFC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5126 10.5579C24.5101 10.2205 24.3211 9.89577 24.0328 9.72264L21.4193 8.14337C20.9489 7.85915 20.3377 8.01063 20.0541 8.48171C19.7704 8.9528 19.9216 9.565 20.3919 9.84915L20.973 10.2003C18.3288 11.103 15.9489 12.7129 14.1139 14.8712C11.7155 17.6924 10.3945 21.2896 10.3945 25C10.3945 28.7104 11.7155 32.3076 14.114 35.1288C16.4852 37.9178 19.7658 39.7921 23.3515 40.4062C23.4083 40.4159 23.4647 40.4207 23.5204 40.4207C23.996 40.4207 24.4165 40.0777 24.4994 39.5923C24.592 39.05 24.2282 38.5353 23.6869 38.4426C20.5598 37.9069 17.6979 36.2713 15.6283 33.8371C13.5358 31.3761 12.3835 28.2376 12.3835 25C12.3835 21.7624 13.5358 18.6239 15.6283 16.1628C17.2054 14.3077 19.243 12.9173 21.5072 12.1232L21.1545 12.7502C20.8849 13.2296 21.0542 13.837 21.5327 14.107C21.687 14.194 21.8546 14.2354 22.0199 14.2354C22.3673 14.2354 22.7046 14.0528 22.8873 13.7281L24.382 11.0707C24.469 10.9149 24.5179 10.7368 24.5126 10.5579Z",
    fill: "#88C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8861 14.8712C35.515 12.0822 32.2344 10.2079 28.6486 9.59374C28.1071 9.5011 27.5933 9.8654 27.5007 10.4076C27.4081 10.9499 27.7719 11.4646 28.3133 11.5574C31.4403 12.0931 34.3022 13.7286 36.3718 16.1628C38.4643 18.6239 39.6166 21.7624 39.6166 25C39.6166 28.2376 38.4643 31.376 36.3718 33.8372C34.7946 35.6923 32.7571 37.0827 30.4929 37.8768L30.8456 37.2497C31.1152 36.7704 30.9459 36.163 30.4674 35.893C29.9888 35.6231 29.3824 35.7926 29.1128 36.2719L27.6181 38.9293C27.3491 39.3817 27.5123 40.0132 27.9673 40.2773L30.5808 41.8566C30.7415 41.9537 30.9186 42 31.0936 42C31.4306 42 31.7594 41.8284 31.9461 41.5183C32.2298 41.0472 32.0786 40.435 31.6083 40.1508L31.0272 39.7997C33.6713 38.897 36.0512 37.2871 37.8862 35.1288C40.2847 32.3076 41.6056 28.7105 41.6056 25C41.6056 21.2895 40.2847 17.6924 37.8861 14.8712Z",
    fill: "#88C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 26.1953L26.6499 27.7699L25.9999 29.5654C25.4509 29.5654 25.0054 29.1198 25.0054 28.5693V27.1914C25.0054 26.6416 25.4509 26.1953 25.9999 26.1953Z",
    fill: "#ACAEB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9945 27.1914V28.5693C26.9945 29.1198 26.549 29.5654 26 29.5654V26.1953C26.549 26.1953 26.9945 26.6416 26.9945 27.1914Z",
    fill: "#717680"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_105_9846",
    x: 0.5,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_105_9846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_105_9846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_9846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSvg);
export default __webpack_public_path__ + "static/media/ResetSvg.ea0364289f468467af45f04718dfb2f0.svg";
export { ForwardRef as ReactComponent };